module.exports = __webpack_public_path__ + "img/o2o09.bd036031.png";